// apps/web/src/lib/consent-defaults.ts — Phase 4 plan 04-03.
//
// Web-side twin of `apps/api/src/lib/consent-defaults.ts`. The
// wizard's A5 step renders the consent text from
// `Restaurant.consentText[locale]` when the API returns it; when
// the API returns null in BOTH DE and EN the wizard falls back
// to this bundled constant (D-15). The values MUST match the
// server-side export — divergence would mean the user sees one
// sentence on the wizard and the server persists a different one.
//
// A canary test (`apps/web/src/wizard/__tests__/consent-defaults-web.test.ts`)
// reads both files as text and asserts the strings are equal
// (Pitfall 16: "default drift"). The test will fail loudly if
// either side is edited in isolation.

export interface ConsentDefaults {
  de: string;
  en: string;
}

export const CONSENT_DEFAULTS: ConsentDefaults = {
  de: "Ich willige in die Verarbeitung meiner Daten zur Bearbeitung dieser Reservierung ein. Die Datenschutzerklärung des Restaurants ist auf Anfrage einsehbar.",
  en: "I consent to my data being processed to handle this reservation. The restaurant's privacy policy is available on request.",
};
